module.exports = __webpack_public_path__ + "img/module_image2.99994869.png";